// extracted by mini-css-extract-plugin
export default {"mantine-LoadingOverlay-overlay":"Overlay_mantine-LoadingOverlay-overlay__2B9uQ"};